/**
 * TanStack Query hooks for `admitad-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	createCredential,
	listCredentials,
	getStatus,
	admitadIntegrationQueryKeys,
	type CreateCredentialBody,
	type CredentialRow,
	type ListCredentialsResponse,
	type SyncStatusResponse,
} from "./api";

export function useAdmitadCredentialsList(): UseQueryResult<
	ListCredentialsResponse,
	Error
> {
	return useQuery({
		queryKey: admitadIntegrationQueryKeys.credentials(),
		queryFn: listCredentials,
	});
}

export function useAdmitadSyncStatus(): UseQueryResult<SyncStatusResponse, Error> {
	return useQuery({
		queryKey: admitadIntegrationQueryKeys.status(),
		queryFn: getStatus,
	});
}

export function useAdmitadCredentialCreate(): UseMutationResult<
	{ ok: boolean; item: CredentialRow },
	Error,
	CreateCredentialBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: createCredential,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: admitadIntegrationQueryKeys.all });
		},
	});
}
